type NavigatorWithUserAgentData = Navigator & {
  userAgentData?: {
    brands?: Array<{ brand: string }>;
  };
};

export const canRenderGooglePayOption = () => {
  if (typeof window === 'undefined') return false;

  const userAgentData = (window.navigator as NavigatorWithUserAgentData).userAgentData;
  const userAgentBrands = userAgentData?.brands?.map(({ brand }) => brand.toLowerCase()) || [];
  if (userAgentBrands.length > 0) {
    return userAgentBrands.some(brand => brand.includes('chrome') || brand.includes('edge'));
  }

  const userAgent = window.navigator.userAgent.toLowerCase();
  return (
    userAgent.includes('chrome') ||
    userAgent.includes('crios') ||
    userAgent.includes('headlesschrome') ||
    userAgent.includes('edg') ||
    userAgent.includes('edge')
  );
};
